import { Button } from "react-bootstrap";
import { useState } from "react";
import { formatRangeDateForApi } from "../helpers/utils";

const AddToSummaryButton = ({ range }) => {
    const [loading, setLoading] = useState(false);

    const handleAddToSummary = async () => {
        const start = formatRangeDateForApi(range.startDate);
        const end = formatRangeDateForApi(range.endDate);

        setLoading(true);

        try {
            const res = await fetch("/api/update-range", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ start, end }),
            });

            if (!res.ok) throw new Error("Помилка під час запуску пересинку");

            alert(
                `⏳ Пересинк за ${start}–${end} запущено на сервері у фоні. Великий період (місяць) може синхронізуватись 1–2 хвилини — зачекайте і оновіть сторінку, щоб побачити свіжі дані.`
            );
        } catch (err) {
            console.error("❌ Помилка під час запуску пересинку:", err);
            alert("Помилка під час запуску пересинку");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            variant="success"
            className="ms-2"
            onClick={handleAddToSummary}
            title="Перезавантажити замовлення за період з KeyCRM (виправляє застарілі суми/статуси в кеші). Триває у фоні на сервері."
            // disabled={true}
        >
            {loading ? "Запуск..." : "Пересинк даних з KeyCRM"}
        </Button>
    );
};

export default AddToSummaryButton;
